<template>
  <div class="overview-wrap">
    <div class="line"></div>
    <div class="item">
      <div class="title">{{ studentInfo.studentName }}</div>
      <div class="point"></div>
      <div class="title">姓名</div>
    </div>
    <div class="item">
      <div class="title">{{ studentInfo.sex == "1" ? "男" : "女" }}</div>
      <div class="point"></div>
      <div class="title">性别</div>
    </div>
    <div class="item">
      <div class="title">{{studentInfo.monthAge}}月</div>
      <div class="point"></div>
      <div class="title">年龄</div>
    </div>
    <!-- <div class="item">
      <div class="title">{{studentInfo.height}}厘米</div>
      <div class="point"></div>
      <div class="title">身高</div>
    </div>
    <div class="item">
      <div class="title">{{studentInfo.weight}}千克</div>
      <div class="point"></div>
      <div class="title">体重</div>
    </div> -->
    <div class="item">
      <div class="title">{{studentInfo.teacherName}}</div>
      <div class="point"></div>
      <div class="title">测评师</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    ReportData() {
      return this.$store.state.ReportData;
    },
    studentInfo() {
      return this.ReportData.studentInfo || {};
    },
  },
};
</script>

<style scoped lang="scss">
.overview-wrap {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
  position: relative;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    width: 100px;
    .point {
      margin: 10px 0;
      width: 15px;
      height: 15px;
      background: #ffffff;
      border-radius: 50%;
      border: 5px solid green;
    }
  }
  .line {
    position: absolute;
    width: 95%;
    border: 5px solid green;
    border-radius: 5px;
    top: calc(50% - 5px);
    z-index: 1;
  }
}
</style>